import { SideSheet, Pane } from 'evergreen-ui';
import { FunctionComponent } from 'react';
import { Dispatch } from 'redux';
import { UsersSection } from './UsersSection';
import { BrowseSection } from './BrowseSection';
import { Footer } from './Footer';

type MobileMenuProps = {
    authenticated: boolean;
    dispatch: Dispatch;
    mobileMenuShown: boolean;
    setMobileMenuShown: (newValue: boolean) => void;
    uTMDetails: { [key: string]: string };
};

export const MobileMenu: FunctionComponent<MobileMenuProps> = ({
    authenticated,
    dispatch,
    mobileMenuShown,
    setMobileMenuShown,
    uTMDetails,
}) => {
    return (
        <SideSheet
            width="85vw"
            isShown={mobileMenuShown}
            onCloseComplete={() => setMobileMenuShown(false)}
        >
            <Pane padding={30} className="nav-mobile-menu-container">
                <UsersSection authenticated={authenticated} />
                <BrowseSection
                    dispatch={dispatch}
                    setMobileMenuShown={setMobileMenuShown}
                    uTMDetails={uTMDetails}
                />
                <Footer />
            </Pane>
        </SideSheet>
    );
};
